import "./reset.css";
import "./styles.css";
import { searchWeather } from "./dataRequest";

const rootElem = document.documentElement;
const locationForm = document.querySelector(".location-form");
const locationInput = document.querySelector(".location-search-box");
const unitInput = document.querySelector(".unit-selector");
const resultsElem = document.querySelector(".weather-result");
const dialogElem = document.querySelector("#loading-screen")

function displayData(data) {
  resultsElem.replaceChildren();
  // const {address, currentCondition, currentTemp, currentTempMin, currentTempMax} = data;
  for (const key in data) {
    if (key === "conditionKeyword") {
      changePageStyle(data[key]);
      continue;
    }
    const dataElem = Object.assign(document.createElement("div"), {
      textContent: data[key],
      classList: key,
    });
    resultsElem.appendChild(dataElem);
  }
}

function changePageStyle(condition) {
  switch (condition) {
    case "partly-cloudy-day":
      rootElem.style.setProperty("--bg", "#80ABBF");
      rootElem.style.setProperty("--text-color", "black");
      break;
    case "rain":
      rootElem.style.setProperty("--bg", "#667294");
      rootElem.style.setProperty("--text-color", "white");
      break;
    case "clear-day":
      rootElem.style.setProperty("--bg", "#8EDBED");
      rootElem.style.setProperty("--text-color", "black");
      break;
    case "clear-night":
      rootElem.style.setProperty("--bg", "#002B3D");
      rootElem.style.setProperty("--text-color", "white");
      break;
    case "partly-cloudy-night":
      rootElem.style.setProperty("--bg", "#223138");
      rootElem.style.setProperty("--text-color", "white");
      break;
    case "cloudy":
      rootElem.style.setProperty("--bg", "#667294");
      rootElem.style.setProperty("--text-color", "white");
      break;
    default:
      break;
  }
}

locationForm.addEventListener("submit", (e) => {
  e.preventDefault();
  const location = locationInput.value;
  const unit = unitInput.value;
  locationInput.value = "";

  dialogElem.showModal();

  searchWeather(location, unit).then((data) => {
    displayData(data);
    dialogElem.close();
  });
});
